export function createProfileSavedViewKey(division, brand, fieldOfPlay) {
    return `${division}|${brand}|${fieldOfPlay}`;
}
